"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisagreementReportSchema = exports.DisagreementNearMissSchema = exports.DisagreementNearMissColumnSchema = exports.DisagreementRowSchema = exports.DisagreementCellSchema = void 0;
const z = require("zod");
const consensus_types_1 = require("../Consensus/consensus.types");
const slice_key_1 = require("../Consensus/slice-key");
const package_data_adjudication_types_1 = require("../PackageDataAdjudication/package-data-adjudication.types");
const json_value_1 = require("../Utils/json-value");
exports.DisagreementCellSchema = z.object({
    anchor: consensus_types_1.FieldAnchorSchema,
    groundTruth: package_data_adjudication_types_1.ComparedValueSchema,
    inferred: package_data_adjudication_types_1.ComparedValueSchema,
});
exports.DisagreementRowSchema = z.object({
    anchor: consensus_types_1.RowAnchorSchema,
    direction: package_data_adjudication_types_1.DiscrepancyDirectionSchema,
    rowContentRaw: json_value_1.JsonValueSchema,
});
exports.DisagreementNearMissColumnSchema = z.object({
    column: z.string(),
    groundTruth: package_data_adjudication_types_1.ComparedValueSchema,
    inferred: package_data_adjudication_types_1.ComparedValueSchema,
});
exports.DisagreementNearMissSchema = z.object({
    groundTruthRowKey: z.string(),
    inferredRowKey: z.string(),
    matchedColumns: z.string().array(),
    differingColumns: exports.DisagreementNearMissColumnSchema.array(),
});
exports.DisagreementReportSchema = z.object({
    sliceKey: slice_key_1.SliceKeySchema,
    sliceVersion: z.number().int(),
    cells: exports.DisagreementCellSchema.array(),
    rows: exports.DisagreementRowSchema.array(),
    missingColumns: z.string().array(),
    duplicateRowKeys: z.string().array(),
    nearMisses: exports.DisagreementNearMissSchema.array().optional(),
});
//# sourceMappingURL=disagreement-report.js.map